type ReloadCapableElement = {
  reload?: (...args: unknown[]) => unknown
  formId?: string | number
  pageDataSlot?: string
  fieldName?: string
  elementId?: string | number
  getContext?: () => { formPath?: { formId?: string | number; pageDataSlot?: string } }
  ctx?: { formPath?: { formId?: string | number; pageDataSlot?: string } }
}

function readTargetFormId(actionContext?: Record<string, unknown>): string {
  return String(
    actionContext?.formId ??
      (actionContext?.formPath as { formId?: unknown } | undefined)?.formId ??
      '',
  ).trim()
}

function readTargetPageDataSlot(actionContext?: Record<string, unknown>): string {
  return String(
    actionContext?.pageDataSlot ??
      (actionContext?.formPath as { pageDataSlot?: unknown } | undefined)?.pageDataSlot ??
      '',
  ).trim()
}

function elementMatchesReloadContext(
  entry: ReloadCapableElement | undefined,
  elementName: string,
  targetFormId: string,
  targetSlot: string,
): boolean {
  if (!entry || typeof entry.reload !== 'function') return false
  const normalizedName = String(elementName ?? '').trim()
  const fieldName = String(entry.fieldName ?? normalizedName).trim()
  if (fieldName !== normalizedName) return false

  const entryFormId = String(entry.formId ?? '').trim()
  const entrySlot = String(entry.pageDataSlot ?? '').trim()

  if (targetFormId && entryFormId && entryFormId !== targetFormId) {
    return false
  }
  if (targetSlot && entrySlot && entrySlot !== targetSlot) {
    return false
  }
  return true
}

/**
 * Находит зарегистрированный элемент для reload с учётом formId/pageDataSlot.
 */
export function resolveRegisteredElementForReload(
  elements: Record<string, ReloadCapableElement | undefined>,
  elementName: string,
  actionContext?: Record<string, unknown>,
): ReloadCapableElement | undefined {
  const name = String(elementName ?? '').trim()
  if (!name) return undefined

  const targetFormId = readTargetFormId(actionContext)
  const targetSlot = readTargetPageDataSlot(actionContext)

  const direct = elements[name]
  if (elementMatchesReloadContext(direct, name, targetFormId, targetSlot)) {
    return direct
  }

  for (const entry of Object.values(elements)) {
    if (elementMatchesReloadContext(entry, name, targetFormId, targetSlot)) {
      return entry
    }
  }

  return undefined
}
